import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

export const authService = {
    login,
    loginWithGoogle,
    loginWithGoogleOneTap,
    getCurrentUser,
    updateUser,
    updatePersonalSettings,
    updateLastVisit,
    forgotPassword,
    resetPassword,
    getEmailByToken,
    deleteUser,
    signup,
    verifyEmail,
    resendEmail,
    createAccountViaStripe,
};

function getEmailByToken(resetToken) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ resetToken }),
    };

    return fetch(`${BASE_URL}api/identity/emailbytoken`, requestOptions)
        .then(response => response.json())
        .then(data => data);
}

function forgotPassword(email) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
    };

    return fetch(`${BASE_URL}api/identity/forgot-password`, requestOptions).then(handleResponse);
}

function resetPassword(password, resetToken) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password, resetToken }),
    };

    return fetch(`${BASE_URL}api/identity/reset-password`, requestOptions).then(handleResponse);
}

function updateUser(user) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(user),
    };
    return fetch(`${BASE_URL}api/users`, requestOptions).then(handleResponse);
}

function updatePersonalSettings(values) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(values),
    };
    return fetch(`${BASE_URL}api/users/personal-settings`, requestOptions)
        .then(handleResponse)
        .then(data => data);
}

function updateLastVisit(lastVisit) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ LastVisit: lastVisit }),
    };

    return fetch(`${BASE_URL}api/users/last-visit`, requestOptions).then(handleResponse);
}

function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ Email: username, Password: password }),
    };

    return fetch(`${BASE_URL}api/identity/authenticate`, requestOptions).then(handleResponse);
}

function loginWithGoogle(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/identity/login-with-google`, requestOptions).then(handleResponse);
}

function loginWithGoogleOneTap(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/identity/login-with-google-one-tap`, requestOptions).then(handleResponse);
}

function getCurrentUser() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/users/current-user`, requestOptions)
        .then(handleResponse)
        .then(user => user);
}

function deleteUser(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/users/${id}`, requestOptions).then(handleResponse);
}

function signup(values) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
    };

    return fetch(`${BASE_URL}api/identity/registration`, requestOptions)
        .then(handleResponse)
        .then(user => user);
}

function verifyEmail(token) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
    };

    return fetch(`${BASE_URL}api/identity/validatebytoken/${token}`, requestOptions)
        .then(handleResponse)
        .then(user => user);
}

function resendEmail() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/identity/resend-email-verification`, requestOptions).then(handleResponse);
}

function createAccountViaStripe(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/stripe/create-account`, requestOptions)
        .then(handleResponse)
        .then(user => user);
}
